import React, { Component } from 'react';
import Content from '../../components/Content';

class VR extends Component {
  componentDidMount() {
    document.title = 'A1 Xplore TV VR - A1 Xplore TV GO';
  }

  render() {
    return <Content resource="VR" />;
  }
}

export default VR;
